module.exports = __webpack_public_path__ + "img/intro_no.5c388a86.svg";